import axios from './axiosInstance';

import type { ImportParseFileResponse } from '../../manage/import/importTypes';

interface ParseImportFileParams {
  sport: string;
  areaId: string;
  jsFile: File;
}

// General import parse endpoint (ullr-140, handler v18): multipart upload of
// one geo file (gpx/kml/tcx/json/geojson, ≤5MB — enforced client-side by the
// FileUploader) returning a FeatureCollection with original properties
// preserved plus normalized `name`/`ullr_difficulty` and the reserved
// `ullr_import` envelope. Mirrors `trail.parseFile`.
const parseImportFile = ({ sport, areaId, jsFile }: ParseImportFileParams): Promise<ImportParseFileResponse> => {
  const url = `/${sport}/areas/${areaId}/import/parsefile`;
  const formData = new FormData();
  formData.append('file', jsFile);
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export default {
  parseImportFile,
};
